import React from 'react';

export default function FAQ() {
  return (
    <div className="faq">
      <h1>FAQs</h1>
    </div>
  );
}
